var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNycTechWeekMobileHeroGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 390 926",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_359_5629)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_359_5629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-309.531 -137.886C-225.717 -89.4382 72.1545 86.0261 113.284 22.921C164.695 -55.9604 -186.624 -86.0696 18.1859 -201.797C209.05 -309.644 448.901 -23.4471 311.176 47.2757C226.544 90.7352 432.92 222.698 525.59 164.237",
    stroke: "url(#paint0_linear_359_5629)",
    strokeWidth: 8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M463.753 602.235C404.049 587.104 191.295 531.323 177.056 577.081C159.256 634.279 379.534 591.818 274.219 698.159C176.075 797.259 -20.355 663.636 51.695 596.472C95.9702 555.2 -53.2349 510.189 -99.8303 562.038",
    stroke: "url(#paint1_linear_359_5629)",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_359_5629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-338.722 695.927C-329.551 572.916 -140.686 607.472 -140.686 607.472C-140.686 607.472 40.6689 625.163 144.707 695.927C274.754 784.383 3.19623 1027.02 -140.686 1062.56C-284.568 1098.11 -350.185 849.691 -338.722 695.927Z",
    fill: "url(#paint2_linear_359_5629)",
    style: {
      mixBlendMode: "color"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_359_5629",
    x: -572,
    y: 371,
    width: 983,
    height: 927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 116,
    result: "effect1_foregroundBlur_359_5629"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359_5629",
    x1: -89.0604,
    y1: 59.6058,
    x2: 350.569,
    y2: 123.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390231,
    stopColor: "#0E97EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819851,
    stopColor: "#23C7CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_359_5629",
    x1: 294.562,
    y1: 519.553,
    x2: 14.4411,
    y2: 556.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390231,
    stopColor: "#0E97EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819851,
    stopColor: "#23C7CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_359_5629",
    x1: 120.678,
    y1: -2461.79,
    x2: 1133.56,
    y2: -2362.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AB2D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_359_5629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 926,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_359_5629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 206,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNycTechWeekMobileHeroGraphic);
export default __webpack_public_path__ + "static/media/nyc-tech-week-mobile-hero-graphic.728f3e617a0d4daf68ad40cba11931fa.svg";
export { ForwardRef as ReactComponent };